import { FixturePage } from '@cds/betting-offer';
import { IntervalLink } from '@frontend/sports/calendar/data-access';
import { CountItem, LeagueItem } from '@frontend/sports/common/core/data-access/sport-model';
import { getReverseEnum } from '@frontend/sports/common/core/utils/extended-types';
import { GridSorting } from '@frontend/sports/grid/core/feature/model';
import { CompetitionRoute } from '@frontend/sports/navigation/core/feature/models';
import { TabBarItem } from '@frontend/sports/web/tab-bar-utils';

import { Tile } from '../shared-models/tile.model';
import type { ShowcaseModuleData } from '../showcase/showcase.model';
import { TeamPagesViewModel } from '../teampages-core/team-pages.model';

export interface FixtureList extends FixturePage {
    sport?: CountItem;
    params?: CompetitionRoute;
    tabs?: TabBarItem[];
    sorting?: GridSorting;
    virtualCompetition?: LeagueItem;
    showcaseData?: ShowcaseModuleData;
    competitionTitle?: string;
    marqueeData?: Tile[];
    teampagesViewModel?: TeamPagesViewModel;
    calendarIntervals?: IntervalLink[];
    calendarPills?: TabBarItem[];
    sportsOverview?: CountItem;
    calendarLiveCounts?: CountItem;
}

export enum FixtureTab {
    Matches = 1,
    Outrights = 2,
    Standings = 3,
    Specials = 4,
    Teams = 5,
    Priceboost = 6,
}

export const ReverseFixtureTab = getReverseEnum(FixtureTab);
